import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ApplicationBase } from 'src/app/base/application-base';
import { IWindowContent } from 'src/app/interfaces/os/window-content.interface';
import { AuthService } from 'src/app/services/auth/auth.service';
import { WindowsManagerService } from 'src/app/services/os/windows-manager.service';
import { ShellService } from 'src/app/services/process/shell.service';
import { IconsService } from 'src/app/services/ux/icons.service';
import { ThemeService } from 'src/app/services/ux/theme.service';

@Component({
  selector: 'app-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends ApplicationBase implements IWindowContent, OnInit {
  private windowId: number;
  private locked = false;
  private lastPicture = "";

  pictureUrl: any = null;

  constructor(
    private sanitizer: DomSanitizer,
    private windowsSv: WindowsManagerService,
    private iconSv: IconsService,
    private shell: ShellService,
    private authSv: AuthService,
    public theme: ThemeService) {
    super();
  }

  ngOnInit(): void {
  }

  get isLocked() {
    return this.locked;
  }

  get isLogged() {
    return this.authSv.isLogged;
  }

  get email() {
    return this.authSv.user.email;
  }

  get picture() {
    const target = (this.isLogged ? this.authSv.user.pictureUrl : this.iconSv.getIcon("user")) || this.iconSv.getIcon("user");

    if (this.lastPicture !== target) {
      this.lastPicture = target;
      if (this.isLogged) {
        this.pictureUrl = this.sanitizer.bypassSecurityTrustUrl(target);
      }
      else {
        this.pictureUrl = target;
      }
    }

    return this.pictureUrl;
  }

  get userName() {
    return this.authSv.isLogged ? this.authSv.user.name : "Guest";
  }

  start(_data: any, windowId: number) {
    this.windowId = windowId;
    this.windowsSv.centerWindow(windowId);
    this.windowsSv.setTitle(windowId, "User profile");
  }

  async login() {
    this.locked = true;

    try {
      this.windowsSv.disableWindow(this.windowId);
      await this.shell.assertSession();
    }
    finally {
      this.locked = false;
      this.windowsSv.enableWindow(this.windowId);
    }
  }
}
